import React, {Component} from "react";

const column = 'col-md-6';

export class features extends Component {

	render() {
		return (
			<div id="features" className="text-center">
				<div className="container">
					<div className="section-title">
						<h2>What we offer</h2>
					</div>

					<div className="row">
						{this.props.data && this.props.data.map((item, i) => (
							<div key={i} className={`col-xs-12 col-md-6 my-auto`}>
								<img src={`img/features/${item.image}.png`} className="img-fluid img-responsive" alt=""/>
								<h2>
									{item.title}
								</h2>
								<h3>
									{item.text}
								</h3>
								<br/><br/>
							</div>
						))}


						{/*<div className="col-xs-12 col-md-6 my-auto">*/}
						{/*	<img src={`img/features/schedule.png`} className="img-fluid img-responsive" alt=""/>*/}
						{/*	<h2>*/}
						{/*		Schedule hours logging*/}
						{/*	</h2>*/}
						{/*	<h3>*/}
						{/*		Set a schedule for recurring appointments and we log add them for you*/}
						{/*	</h3>*/}
						{/*</div>*/}

						{/*<div className="col-xs-12 col-md-6 my-auto">*/}
						{/*	<img src={`img/features/print.png`} className="img-fluid img-responsive" alt=""/>*/}
						{/*	<h2>*/}
						{/*		Generate & Fill Forms*/}
						{/*	</h2>*/}
						{/*	<h3>*/}
						{/*		Select a date range and myHrs will generate required forms with all your totals*/}
						{/*	</h3>*/}
						{/*</div>*/}


					</div>
				</div>
			</div>
		);
	}
}

export default features;



// WEBPACK FOOTER //
// ./src/components/features.jsx